import { apiProxyRequest as request } from "Api/apiProxyRequest";

import { ProjectUserAccess } from "./projectUserAccess.types";

export const getUserAccessByUserId = (projectId: string, userId: string) =>
  request<ProjectUserAccess>(`/projects/${projectId}/user-access/${userId}`);
